<template>
	<div class="box">
		<div class="bookCover">
				<img class="book-image" :src="bookInfo.bookLogoUrl" alt="">
			<div class="book-info">
				<p class="book_name book-info-text">{{bookInfo.bookName}}</p>
				<span class="book_author book-info-text">{{bookInfo.category}}</span>
				<div class="book-info-div">
					<span class="single-author">{{bookInfo.bookFinish===0?'完结':'连载'}} {{bookInfo.bookNum}}万字</span>
				</div>
			</div>
		
		</div>
		<div class="book_score">
			<div style="border-right:1px solid #F3F3F3;"><span>{{bookInfo.bookScore}} </span><span
					style="font-size: 0.75rem;">评分</span></div>
			<div><span>{{bookInfo.studyingVolume}} </span><span style="font-size:0.75rem;">万热度</span></div>
		</div>
		<div class="book-intro">
			<div class="book-intro-div">
				<span class="intro" :class="presentationClass" @click="changeIntro">{{bookInfo.bookSummary}}</span>
			</div>
		</div>
		<div class="cata-enter" @click="routeCata">
			<span class="swiper-main-title">最新章节： 第{{bookInfo.numChapters}}章 {{bookInfo.lastChapterName}} </span>
			<div class="swiper-main-right">
				<span class="swiper-main-right-text">目录</span>
				<img class="swiper-main-right-image" src="../../../../static/forward.png"  alt="">
			</div>
		</div>
		<div class="contaner">
			<span class="chapter-title">第{{cataitem.chapterOrder}}章 {{cataitem.chapterName}}</span>
			<div style="flex-direction: column;">
				<span v-for="(item,index) in content" :key="index">{{item}}</span>
			</div>
			<div class="continue-btn" @click="changeIscontinue">
				<span v-if="!isContinue">继续阅读</span>
				<span v-if="isLastChapter==0&&isContinue">阅读下一章</span>
				<img class="swiper-arrow"  v-if="isLastChapter==0&&isContinue||!isContinue" src="../../../../static/forward.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'book-cover',
		props: {
			bookInfo: {
				type: Object,
				default: {}
			},
			cataitem: {
				type: Object,
				default: {}
			},
			isLastChapter:{
				type:Number,
				default:0
			}
		},
		data() {
			return {
				presentationClass: "content_text",
				wholePresentation: true,
				content: [],
				allContent: [],
				isContinue: false,
			};
		},
		watch: {
			cataitem(val) {
				this.isContinue = false;
				var arr = this.cataitem.chapterContent.split('\n');
				this.content = [];
				this.allContent = [];
				var length = 0;
				arr.forEach((item => {
					if (item && item.trim()) {
						this.allContent.push(item.trim())
						if (this.content.length < 6) {
							this.content.push(item.trim())
						}
					}
				}))
			}
		},
		mounted() {
		},
		methods: {
			
			changeIntro() {
				this.wholePresentation = !this.wholePresentation;
				this.presentationClass = this.wholePresentation ? "content_text" : '';
			},
			routeCata() {
				this.$router.push({
					path:'/pages/bookCatalog/index',
					query:{
						bookId:this.bookInfo.id,
						pageType:'bookDetail'
					}
				})
			
			},
			  changeIscontinue(){
			      if(this.isContinue){
					  this.$emit('goRead',true)
			      }else{
			        this.content=this.allContent;
			        this.isContinue=true;
			      }
			  },
			  
		},
		created() {}
	};
</script>

<style scoped>
	.box{
		padding-top: calc(44px + env(safe-area-inset-top));
		width:100%;
	}
	.contaner {
	  flex-direction: column;
	  padding: 20px 16px;
	  width: 100%;
	  box-sizing: border-box;
	}
	.contaner > .chapter-title {
	  font-size: 16px;
	  color: #333333;
	  font-weight: bold;
	  margin-bottom: 12px;
	  display: block;
	}
	.contaner > .continue-btn {
	    text-align: center;
	   margin-top: 16px;
	}
	.contaner > .continue-btn > span {
	  font-size: 14px;
	  color: #666666;
	  display: inline-block;
	
	}
	.continue-btn > img {
	  width: 8px;
	  height: 14px;
	  margin-left: 8px;
	}
	.contaner > div > span {
	  font-size: 14px;
	  color: #333333;
	  line-height: 24px;
	  text-indent: 1em;
	  display: block;
	}
	.book_score {
		width: 100%;
		font-size: 22px;
		color: #DE3B34;
		padding: 15px 16px;
		display: flex;
		border-bottom: 1px solid #F3F3F3;
		box-sizing: border-box;
	}

	.book_score>div {
		flex: 1;
		text-align: center;
	}

	.bookCover {
		width:100%;
		display: flex;
		padding: 20px 16px;
		background-color: #5F4C4C;
		    /* justify-content: space-between; */
			    box-sizing: border-box;
	}

	.book-image {
		width: 70px;
		height: 92px;
		border-radius: 6px;
		margin-right:16px;
	}

	.book-info {
		width: 210px;
		position: relative;
	}

	.book-info-text {
		display: block;
		color: #ffffff;
	}
	.book_name {
		font-size: 16px;
		font-weight: bold;
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
	}
	.book_reading {
		font-size: 14px;
		margin: 8px 0px;
		font-weight: bold;
	}
	.book_author {
		font-size: 14px;
		margin-top: 8px;
	}
	.book-info-div {
		display: block;
		position: absolute;
		bottom: 0px;
		left: 0px;
		/* margin-top: 16px; */
	}
	.single-author {
		font-size: 12px;
		color: #ffffff;
	}
	.sort {
		background-color: rgb(253, 245, 233);
		border-radius: 2px;
		font-size: 10px;
		padding: 0px 5px;
		color: #F09B28;
	}

	.book-intro {
		padding: 0px 16px;
		width: 100%;
		box-sizing: border-box;
	}

	.book-intro-text {
		font-size: 16px;
		color: #333333;
		font-weight: bold;
	}

	.intro {
		margin-top: 12px;
		display: -webkit-box;
		font-size: 14px;
		color: #666666;
		line-height: 20px;
	}

	.content_text {
		overflow: hidden;
		-webkit-line-clamp: 3;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
	}

	.cata-enter {
		width: 100%;
		box-sizing: border-box;
		margin-top: 12px;
		padding: 12px 16px;
		border-top: 1px solid #f3f3f3;
		border-bottom: 1px solid #f3f3f3;
		justify-content: space-between;
		display: flex;
	}
	.swiper-main-title {
		font-size: 14px;
		color: #333333;
		text-overflow: ellipsis;
		width: 260px;
		white-space: nowrap;
		overflow: hidden;
	}

	.swiper-main-right {
		display: flex;
	}

	.swiper-main-right-text {
		margin-right: 7px;
		font-size: 12px;
		color: #8d8d8d;

	}

	.swiper-main-right-image {
		width: 8px;
		height: 15px;
	}
	
</style>



// WEBPACK FOOTER //
// src/view/bookDetail/component/bookCover.vue